import {ensureValueInArray} from 'common/utils';
import {DiplomatFeature} from 'types/DiplomatFeature';
import {enums} from 'types/enums';
import {ILicense} from 'types/License';

export function injectEntitlments(license: ILicense) {
   // https://coviantsoftware.atlassian.net/browse/WEBADMIN-556 : Add check for ENTERPRISE edition to display Synchronizations
   if (license.edition === enums.LicenseEdition.enum.ENTERPRISE) {
      ensureValueInArray(license.features, DiplomatFeature.SYNCHRONIZATION.id);
      ensureValueInArray(license.features, DiplomatFeature.MULTIPLE_DESTINATIONS.id);
      ensureValueInArray(license.features, DiplomatFeature.SFTP_SERVER.id);
      ensureValueInArray(license.features, DiplomatFeature.EDGE_GATEWAY.id);
      ensureValueInArray(license.features, DiplomatFeature.LDAP.id);
   }

   return license;
}
